import React from "react";
import { Navigate } from "react-router-dom";
import { useAuthContext } from "../context/AuthContext";

const ProtectedRoute = ({ children }) => {
  const { isLoggedIn } = useAuthContext();

  return isLoggedIn ? children : <Navigate to="/" replace />;
};

export default ProtectedRoute;
